// import the api endpoints
import api from "../api";

const initialState = () => ({
    companies: [],
    properties: [],
    currentCompany: {},
    currentProperty: {},
    loading: false,
});

const state = initialState();

const getters = {
    companies: (state) => state.companies,
    currentCompany: (state) => state.currentCompany,
    properties: (state) => state.properties,
    currentProperty: (state) => state.currentProperty,

    loading: (state) => state.loading,
};

const actions = {
    reset({ commit }) {
        commit("RESET");
    },
    async getCurrentCompany({ commit }, id) {
        try {
            commit("SET_LOADING", true);
            let data = await api.getCompany(id);
            commit("SET_CURRENT_COMPANY", data);
            commit("SET_LOADING", false);
        } catch (error) {
            commit("SET_ERROR", error, { root: true });
            commit("SET_LOADING", false);
        }
    },
    async getCompanies({ commit }) {
        try {
            commit("SET_LOADING", true);
            let data = await api.getCompanies();
            commit("SET_COMPANIES", data);
            commit("SET_LOADING", false);
        } catch (error) {
            commit("SET_ERROR", error, { root: true });
        }
    },
    async getCurrentProperty({ commit }, id) {
        try {
            commit("SET_LOADING", true);
            let data = await api.getProperty(id);
            commit("SET_CURRENT_PROPERTY", data);
            commit("SET_LOADING", false);
        } catch (error) {
            commit("SET_ERROR", error, { root: true });
            commit("SET_LOADING", false);
        }
    },
    async getProperties({ commit }) {
        try {
            commit("SET_LOADING", true);
            let data = await api.getProperties();
            commit("SET_PROPERTIES", data);
            commit("SET_LOADING", false);
        } catch (error) {
            commit("SET_ERROR", error, { root: true });
        }
    },
};

const mutations = {
    RESET: (state) => {
        const newState = initialState();
        Object.keys(newState).forEach((key) => {
            state[key] = newState[key];
        });
    },
    SET_COMPANIES: (state, payload) => {
        state.companies = payload;
    },
    SET_CURRENT_COMPANY: (state, payload) => {
        state.currentCompany = payload;
        // Current Property cannot be outside the list of properties for current company
        if (state.currentProperty.company_id !== state.currentCompany.id) {
            state.currentProperty = {};
        }
    },
    SET_PROPERTIES: (state, payload) => {
        state.properties = payload;
    },
    SET_CURRENT_PROPERTY: (state, payload) => {
        state.currentProperty = payload;
    },
    SET_LOADING: (state, payload) => {
        state.loading = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
